import { render, staticRenderFns } from "./OwnerCurrentDay.vue?vue&type=template&id=8930671a&scoped=true&"
import script from "./OwnerCurrentDay.vue?vue&type=script&lang=ts&"
export * from "./OwnerCurrentDay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8930671a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
